// eslint-disable-next-line no-undef
__webpack_public_path__ = window.__webpack_base_url__ === '/mall' ? '/mall/' : '/'

import Vue from 'vue'
import '@components/amumu/index'
import router from '@route'
import store from '@store'
import Filters from '@filters'
import i18n from '@i18n'
import '@assets/iconfont/iconfont.css'
import '@assets/iconfont/iconfont'
import '@assets/sass/reset.scss'
import '@assets/sass/base.scss'
import '@assets/sass/common.scss'
import App from './App.vue'
import AppWx from './AppWx.vue'
import moment from "moment";

Vue.config.productionTip = false
Vue.config.debug = true

Vue.use(Filters)

moment.locale('zh-cn')

window.APP = new Vue({
  store,
  router,
  i18n,
  render: h => h(window.__xm_wx.isMiniProgram ? AppWx : App)
}).$mount('#app')


